export default ({ request }) => ({
  sysMessageTaskListApi(data = {}) {
    return request({
      url: '/sys/messageTask/list',
      method: 'post',
      data,
    })
  },
  sysMessageTaskReshipApi(data = {}) {
    return request({
      url: '/sys/messageTask/reship',
      method: 'post',
      data,
    })
  },
})
